/**
 * 라우트 이동 시 스크롤을 최상단으로 되돌린다.
 *
 * SPA(클라이언트 네비게이션)는 페이지를 새로 로드하지 않아 이전 페이지의 스크롤 위치가
 * 그대로 유지된다. 스크롤을 내린 목록에서 상세로 진입하면 상세가 최하단(푸터)부터
 * 보이는 문제가 생기므로, 새 이동(PUSH/REPLACE)에서는 상단으로 이동시킨다.
 *
 * 단, 뒤로/앞으로(POP) 이동은 브라우저의 스크롤 복원에 맡겨 원래 보던 위치로 돌아가게 한다.
 */
import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()
  const navType = useNavigationType()

  useEffect(() => {
    if (navType === 'POP') return
    window.scrollTo(0, 0)
  }, [pathname, navType])

  return null
}
